module.exports = __webpack_public_path__ + "img/404.d395cc34.png";